import { get, pick } from "lodash";
import { onlineT } from "../../typings/online";
import "./resource";

class OnlineItemService {
    public static $inject: string[] = [
        "onlineItemResource"
    ];

    constructor(
        private onlineItemResource
    ) {}

    public get(id: number) {
        return this.onlineItemResource().get({ id: id }).$promise;
    }

    public update(id: number, fields: Object) {
        return this.onlineItemResource().update({ id: id }, fields).$promise;
    }

    public publish(id: number) {
        return this.onlineItemResource().publish({ id: id }).$promise;
    }

    public getBids(id: number) {
        return this.onlineItemResource().getBids({ id }).$promise;
    }

    public getLastBid(item: onlineT.Item): onlineT.LastBid {
        return get(item, "pricing.last_bid");
    }

    public getLastBidder(item: onlineT.Item): onlineT.LastBidder {
        return pick(this.getLastBid(item), [
            "anonymous_bidder_id",
            "birthday",
            "civility",
            "company",
            "email",
            "first_name",
            "last_name",
            "location",
            "phone_landline",
            "phone_mobile",
            "user_id"
        ]);
    }
}

angular
    .module("thor.core.online-item.service", [
        "thor.core.online-item.resource"
    ])
    .service("onlineItemService", OnlineItemService);
